import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomePage } from './pages/home/home';
import { ForPage } from './pages/for/for';
import { LocationPage } from './pages/location/location';
import { RestaurantPage } from './pages/restaurant/restaurant';
import { ItemPage } from './pages/item/item';

const appRoutes: Routes = [
  { path: 'home', component: HomePage },
  { path: 'for-restaurants', component: ForPage },
  { path: 'location/:loc', component: LocationPage },
  { path: 'restaurant/:uid/:rid', component: RestaurantPage },
  { path: 'item/:uid/:iid', component: ItemPage },
  { path: '**', component: ForPage }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/nikolay/Documents/GitHub/menu-web/src/app/app.routing.module.ts